<template>
	<div class="listModel">
		<div class="back">
			<yd-cell-item>
				<span slot="left" class="back-title">{{item.productName}}</span>
				<span slot="right" class="back-code">合同编号 {{item.contractId}}</span>
			</yd-cell-item>
		</div>
		<div class="backlist">
			<div>
				<p class="blueText">{{item.loanAmount}}</p>
				<span>借款金额/元</span>
			</div>
			<div>
				<p>{{item.repayPeriod||'无'}}</p>
				<span>借款期限/月</span>
			</div>
		</div>
		<div class="backlist" style="border: none">
			<div>
				<p>{{item.loanRate}}%</p>
				<span v-if="item.rateType==1">利率/年</span>
				<span v-if="item.rateType==2">利率/月</span>
				<span v-if="item.rateType==3">利率/日</span>
			</div>
			<div>
				<p>{{item.repayMode}}</p>
				<span>还款方式</span>
			</div>
		</div>
		<div class="back-prorocol blueText" v-if="item.signType==2">
			<router-link to="#">《借款合同》</router-link>
			<router-link to="#">《服务协议》</router-link>
		</div>
<!--		<div v-if="contractStatus==1&&item.repayModeCode!=6" class="back-yd">-->
<!--			<yd-button type="hollow" @click.native="link('earlierPay')">提前结清</yd-button>-->
<!--			<yd-button type="hollow" @click.native="link('payPlan')">还款计划</yd-button>-->
<!--		</div>-->
		<div v-if="contractStatus==1&&item.repayModeCode==6" class="back-yd">
			<yd-button type="hollow" @click.native="link('earlierPayforDay')">立即还款</yd-button>
		</div>
		<div v-if="contractStatus==2" class="back-yd">
			<yd-button type="hollow"  @click.native="link('payDetail')">还款明细</yd-button>
			<p>
				<span>结清日期</span>
				<span>2019-12-16</span>
			</p>
		</div>
	</div>
</template>

<script>
    export default {
        name: "listModel",
	    props: ['item','contractStatus'],
	    methods: {
		    link: function (url) {
			    this.$router.replace({path: '/'+ url, query: {productNo: this.item.productNo,contractId: this.item.contractId,orderId: this.item.orderId}})
		    }
	    },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inputComponent/listModel.vue